import { Typography } from 'antd';

const { Paragraph, Text } = Typography;

export interface AIInsightCardProps {
  title?: string;
  body: string;
}

export function AIInsightCard({ title, body }: AIInsightCardProps) {
  return (
    <div className="ai-prompt-card" style={{ minHeight: 'auto', flexDirection: 'column', alignItems: 'flex-start' }}>
      {title ? (
        <Text strong style={{ display: 'block', marginBottom: 6 }}>
          {title}
        </Text>
      ) : null}
      <Paragraph style={{ margin: 0 }}>{body}</Paragraph>
    </div>
  );
}
